import {
  getCheckoutFormValues,
  setSectionLabel,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, LabelEnum, SectionsEnum } from 'app/shared/enums';

const nameAndLastnameChange = {
  updateCoowner2Label() {
    const name = getCheckoutFormValues().coowners[2].nameCheckoutForm || '';
    const lastName =
      getCheckoutFormValues().coowners[2].lastNameCheckoutForm || '';
    setSectionLabel({
      key: SectionsEnum.CheckoutSectionInsurant4Owner,
      formName: FormsEnum.CheckoutForm,
      label: `${LabelEnum.CoOwner} - ${name} ${lastName}`,
    });
  },
};

export default nameAndLastnameChange;
